import React from 'react';
import PropTypes from 'prop-types';
import FalconCardFooterLink from 'components/common/FalconCardFooterLink';
import { Card } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { Link } from 'react-router-dom';
import Avatar from 'components/common/Avatar';
import classNames from 'classnames';

const ActiveDevices = ({ users, end = 5, ...rest }) => {
  const deviceCount = users ? users.length : 0;
  const deviceLabel = deviceCount === 1 ? 'device' : 'devices';
  const visibleUsers = users ? users.slice(0, end) : [];
  const hiddenDeviceCount = Math.max(deviceCount - visibleUsers.length, 0);

  return (
    <Card {...rest}>
      <Card.Header className="pb-2">
        <h6 className="mb-0 mt-2">Active Devices</h6>
        <p className="text-600 fs--1 mb-0 mt-2">
          {deviceCount} {deviceLabel} registered to your account
        </p>
      </Card.Header>
      <Card.Body className="pt-3 pb-2">
        {visibleUsers.map(({ id, ...rest }, index) => (
          <ActiveDevice
            {...rest}
            key={id + '-' + index}
            isLast={index === visibleUsers.length - 1 && !hiddenDeviceCount}
          />
        ))}
        {hiddenDeviceCount > 0 && (
          <p className="text-600 fs--1 mb-0 mt-2">
            ... and {hiddenDeviceCount} more
          </p>
        )}
      </Card.Body>
      <FalconCardFooterLink
        title="View all devices"
        to="/account/devices"
        size="sm"
      />
    </Card>
  );
};

const ActiveDevice = ({ name, icon, Lastseen, blocked, isLast }) => (
  <Flex className={classNames('align-items-center', { 'mb-3': !isLast })}>
    <Avatar
      icon={icon}
      size="xl"
      className={`status-${blocked ? 'offline' : 'online'}`}
    />
    <div className="ms-3">
      <h6 className="mb-0 fw-semi-bold">
        <Link className="text-900" to="#">
          {name}
        </Link>
      </h6>
      <p className="text-500 fs--2 mb-0">Last seen {Lastseen}</p>
    </div>
  </Flex>
);

ActiveDevice.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.any,
  Lastseen: PropTypes.any,
  blocked: PropTypes.bool,
  isLast: PropTypes.bool
};

ActiveDevices.propTypes = {
  users: PropTypes.array,
  end: PropTypes.number
};

export default ActiveDevices;
